/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Guide_Rest_ApiInputs */

const en_sidebar_guide_rest_api = /** @type {(inputs: Sidebar_Guide_Rest_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON & REST API`)
};

const ko_sidebar_guide_rest_api = /** @type {(inputs: Sidebar_Guide_Rest_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON & REST API`)
};

const ja_sidebar_guide_rest_api = /** @type {(inputs: Sidebar_Guide_Rest_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON & REST API`)
};

/**
* | output |
* | --- |
* | "JSON & REST API" |
*
* @param {Sidebar_Guide_Rest_ApiInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_guide_rest_api = /** @type {((inputs?: Sidebar_Guide_Rest_ApiInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Guide_Rest_ApiInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_guide_rest_api(inputs)
	if (locale === "ko") return ko_sidebar_guide_rest_api(inputs)
	return ja_sidebar_guide_rest_api(inputs)
});